// Physical state matrix: one material id per cell (ids come from the material registry).
import { ROCK } from '../materials';
import { createGrid, type Grid } from './grid';

export {
  EMPTY, ROCK, SAND, WATER, LAVA, WOOD, STEAM, OBSIDIAN, FIRE, BLACK_POWDER, OIL, ACID, ICE, GRAVEL, ENTITY,
} from '../materials';

export type PhysiqueMatrix = Grid;

export function createPhysique(w: number, h: number): PhysiqueMatrix {
  return createGrid(w, h);
}

/** Outside the map reads as rock: nothing falls or flows out of the grid. */
export function get(m: PhysiqueMatrix, x: number, y: number): number {
  if (x < 0 || x >= m.w || y < 0 || y >= m.h) return ROCK;
  return m.data[y * m.w + x];
}

/** Raw write that does not wake the simulation: prefer setCell(world, ...) outside world generation. */
export function set(m: PhysiqueMatrix, x: number, y: number, value: number): void {
  if (x >= 0 && x < m.w && y >= 0 && y < m.h) {
    m.data[y * m.w + x] = value;
  }
}

/** Raw fill that does not wake the simulation: call wakeAll(world) afterwards. */
export function fill(m: PhysiqueMatrix, value: number): void {
  m.data.fill(value);
}
